import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { AnimatePresence, motion } from "framer-motion";
import building from "../../assets/images/building.png";
import logo from "../../assets/images/logo.png";
import RegistrationForm from "./RegisterForm";
import ApiService from "../../services/ApiService";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import AuthGuard from "../../components/AuthGuard";
import { useTranslation } from "react-i18next";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

const CompanyForm = () => {
  const [view, setView] = useState("main");
  const [isLoader, setIsLoader] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  const handleLocalSubmit = (e) => {
    e.preventDefault();
    if (companyName.trim()) {
      localStorage.setItem("companyName", companyName.trim());
      setView("company");
    }
  };

  const handleApiSubmit = async () => {
    const payload = {
      company_name: companyName.trim(),
    };

    if (!payload.company_name) {
      toast.error("Company name is required.");
      return;
    }

    try {
      setIsLoader(true);
      const response = await ApiService.request({
        method: "POST",
        url: `/company/register`,
        data: payload,
      });

      const data = response.data;
      if (data.status) {
        // toast.success(data.message);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Registration failed! Please try again.");
    } finally {
      setIsLoader(false);
    }
  };

  return (
    <AuthGuard>
      <Header />
    <AnimatePresence mode="wait">
      {view === "main" ? (
        <motion.div
          key="main-view"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -50 }}
          transition={{ duration: 0.5 }}
          className="inter-font main-bg min-vh-100 d-flex flex-column justify-content-center align-items-center px-3"
        >
          <Container fluid className="inter-font position-absolute top-0 mt-3 px-3">
            <Row className="inter-font align-items-center justify-content-center">
              {/* Logo Removed */}

              {/* Steps */}
 <Col xs={12} className="inter-font text-center">
  <div className="inter-font d-flex flex-md-row align-items-center justify-content-center gap-2">
    <div className="inter-font d-flex align-items-center justify-content-center">
      <Step active>1</Step>
      <span className="inter-font sofia-font fs-count" style={{ [isRTL ? "marginRight" : "marginLeft"]: "8px" }}>
        {t("select_company")}
      </span>
    </div>
    <Arrow />
    <div className="inter-font d-flex align-items-center justify-content-center">
      <Step>2</Step>
      <span className="inter-font sofia-font fs-count" style={{ [isRTL ? "marginRight" : "marginLeft"]: "8px" }}>
        {t("add_information")}
      </span>
    </div>
    <Arrow />
    <div className="inter-font d-flex align-items-center justify-content-center">
      <Step>3</Step>
      <span className="inter-font sofia-font fs-count" style={{ [isRTL ? "marginRight" : "marginLeft"]: "8px" }}>
        {t("upload_documents")}
      </span>
    </div>
  </div>
</Col>
              
            </Row>
          </Container>
<div
  className="inter-font text-center mt-5 pt-5 px-3 w-100"
  style={{ maxWidth: "600px", direction: isRTL ? "rtl" : "ltr" }}
>
  <div
    className="inter-font rounded-circle bg-light d-inline-flex align-items-center justify-content-center mb-3"
    style={{ width: "60px", height: "60px" }}
  >
    <img src={building} className="inter-font w-75" alt="Building" />
  </div>
  <h2 className="inter-font fw-bold" style={{ textAlign: "center" }}>
    {t("c_reg_title")}
  </h2>
  <p className="inter-font sofia-font mb-4" style={{ color: "#929292", textAlign: "center" }}>
    {t("c_reg_dec")}
  </p>
  <Form onSubmit={handleLocalSubmit} className="inter-font w-100">
    <Form.Group className="inter-font mb-4" controlId="companyName">
      <Form.Control
        type="text"
        value={companyName}
        onChange={(e) => {
          const value = e.target.value;
          if (/^[a-zA-Z0-9\s]*$/.test(value)) {
            setCompanyName(value);
          }
        }}
        name="company_name"
        placeholder={t("c_ff_text24")}
        className="inter-font py-3 rounded-3 sofia-font inp-login w-100"
        required
        dir="ltr"
        style={{ textAlign: isRTL ? "right" : "left" }}
      />
    </Form.Group>

    <Button
      type="submit"
      className="inter-font btn btn-base px-5 border-0 mt-3"
      style={{
        backgroundColor: "#E26A52",
        color: "#fff"
      }}
    >
      {t("c_continue")}
    </Button>
  </Form>
</div>
        </motion.div>
      ) : (
        <motion.div
          key="company-view"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -50 }}
          transition={{ duration: 0.5 }}
        >
          <RegistrationForm
            onNext={() => handleApiSubmit()}
            isLoading={isLoader}
          />
        </motion.div>
      )}
    </AnimatePresence>
    <Footer />
    </AuthGuard>
  );
};

const Step = ({ children, active }) => (
  <div
    className={ `inter-font rounded-circle d-flex num-circle align-items-center justify-content-center fw-bold ${
      active ? "bg-dark text-white" : "bg-light text-muted"
    }`}
    style={{ width: "30px", height: "30px", fontSize: "14px" }}
  >
    {children}
  </div>
);

const Arrow = () => <span className="inter-font text-muted">→</span>;

export default CompanyForm;
